import { render } from "./ShippingUnit.vue?vue&type=template&id=33616b79&scoped=true"
import script from "./ShippingUnit.vue?vue&type=script&lang=js"
export * from "./ShippingUnit.vue?vue&type=script&lang=js"

import "./ShippingUnit.vue?vue&type=style&index=0&id=33616b79&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33616b79"

export default script